export default __webpack_public_path__ + "static/media/Jaguar Transparente.d8397ebd.png";